import React, { useState } from "react"

// import {
//     validationSchema as _validationSchema,
//     initialValues as _initialValues,

//     initialRowValues as _initialRowValues,
//     containerSizes as _containerSizes,
//     containerTypes as _containerTypes,

//     customInjectionProps as _customInjectionProps,
//     customInjectionFields as _customInjectionFields
// } from "../../schema/repositories/containerSchema";

import {
    useInjectionFields,
    getUpdateFieldValuesPayload,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

// import {
//     useProduct,
//     productInjectionFields
// } from "./useProduct"

import { getInjectionDataType } from "../../utils/injectionSelection";
import { customInjectionFields as itemInjectionFields } from "../../schema/items/itemSchema";

import { createContainerInjectionFieldsPayload } from "../../utils/injectionFields";

// export const validationSchema = _validationSchema
// export const initialValues = _initialValues

// export const initialRowValues = _initialRowValues
// export const containerTypes = _containerTypes
// export const containerSizes = _containerSizes

// export const containerInjectionProps = _customInjectionProps
// export const containerInjectionFields = _customInjectionFields

import { formatRoundValue } from "../../utils/formatNumber";

export function useContainerSummary({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const { updateFieldValues, filterOperatorTypes } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.repository.id
    });

    // const { getProduct } = useProduct({ routeType })

    const updateContainerSummary = async ({
        containerId,
        listProducts // pass in the useProduct -> listProducts
    }) => {

        const props = {
            limit: -1,
            skip: 0,
            filterValue: [],
            sortInfo: {
                id: 'id',
                dir: 0,
            },
        };

        let { data: containerProducts } = await listProducts({
            props,
            loadContainerIds: [containerId],
            dataTypes: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]
        })

        let totalCbm = 0
        let totalValue = 0
        let totalPackQty = 0
        let totalWeight = 0

        containerProducts.forEach(i => {
            let items = i?.items

            items.forEach(i => {

                let _totalCbm = i[itemInjectionFields.totalCbm.retrieveKey]
                let _totalValue = i[itemInjectionFields.totalValue.retrieveKey]
                let _totalWeight = i[itemInjectionFields.totalWeight.retrieveKey]
                let _totalPackQty = i[itemInjectionFields.packQty.retrieveKey]

                totalCbm += parseFloat(_totalCbm)
                totalValue += parseFloat(_totalValue)
                totalWeight += parseFloat(_totalWeight)
                totalPackQty += parseFloat(_totalPackQty)

            })
        })

        // console.log('containerProducts, containerProducts', containerProducts)

        // console.log('totalCbm', totalCbm)
        // console.log('totalValue', totalValue)
        // console.log('totalPackQty', totalPackQty)
        // console.log('totalWeight', totalWeight)

        totalCbm = formatRoundValue(totalCbm, 4)
        totalValue = formatRoundValue(totalValue, 2)
        totalPackQty = formatRoundValue(totalPackQty, 2)
        totalWeight = formatRoundValue(totalWeight, 4)

        // console.log('totalCbm', totalCbm)
        // console.log('totalValue', totalValue)
        // console.log('totalPackQty', totalPackQty)
        // console.log('totalWeight', totalWeight)

        // append inj fields - for container info
        let injectionFieldsContainer = createContainerInjectionFieldsPayload({
            containerId,
            data: {
                totalCbm,
                totalValue,
                totalPackQty,
                totalWeight
            },
            targetInjectionFieldIds: [
                `totalCbm`,
                `totalValue`,
                `totalPackQty`,
                `totalWeight`,
            ],
        })

        // injection fields
        let response = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsContainer }), overrideScopeType: injectionFieldScopeTypes.repository.id })

        return {
            totalCbm,
            totalValue,
            totalPackQty,
            totalWeight,
            response
        }
    }

    return {
        filterOperatorTypes,
        // checkProductIsLoadedContainer,
        updateContainerSummary
    }
}